import { useEffect, useState } from 'react';
import { useApi } from './useApi';
import { useAuth } from '../App';
export function useMoney() {
  const { fetchApi } = useApi();
  const { currentShop } = useAuth();
  const [currency,setCurrency] = useState<string | null>(null);
  useEffect(() => { setCurrency(null); void fetchApi<{ currency: string | null }>('/settings/currency').then(r => setCurrency(r?.currency || null)); },[currentShop?.id]);
  return (amount: number | null, override?: string) => {
    if (amount === null) return '-';
    const code = override || currency;
    if (!code) return `${Number(amount).toFixed(2)} (set currency in Settings)`;
    return new Intl.NumberFormat('en-GB',{ style:'currency',currency:code }).format(amount);
  };
}
